import React from 'react';
import { useQuery } from 'react-query';
import api from '../../services/api';

const MeusPedidos = () => {
  const { data, isLoading } = useQuery(
    'meus-pedidos',
    async () => {
      const response = await api.get('/api/pedidos/meus-pedidos');
      return response.data.data.pedidos;
    }
  );

  if (isLoading) {
    return <div className="loading">Carregando...</div>;
  }

  return (
    <div>
      <h2>Meus Pedidos</h2>
      {data?.map((pedido) => (
        <div key={pedido._id} className="card" style={{ marginBottom: '1rem' }}>
          <h3>Pedido #{pedido.numero}</h3>
          <p>Status: {pedido.status}</p>
          <p>Total: R$ {pedido.total?.toFixed(2)}</p>
        </div>
      ))}
    </div>
  );
};

export default MeusPedidos;

